import { useFormikContext } from "formik";
import React from "react";

import { IGivenOnRentProperties } from "../../../../config/interfaces";
import { FormField, NumericInputField } from "../../../fields";

type Props = {};

const RINetTaxableIncomeForm: React.FC<Props> = (props: Props) => {
	const { values, errors, touched, setFieldValue, handleBlur } =
		useFormikContext<IGivenOnRentProperties>();

	return (
		<>
			<section className="mb-5">
				<FormField
					label={
						<>
							Income chargeable from house property
							<small>
								It is the difference between Net income (as per your share) & Deduction (as per your
								share)
							</small>
						</>
					}
					sm={6}
				>
					<NumericInputField
						showLeftIcon={true}
						name="NetTaxableIncome"
						value={values.NetTaxableIncome}
						onBlur={handleBlur("NetTaxableIncome")}
						onChange={(value) => setFieldValue("NetTaxableIncome", value)}
						isInvalid={Boolean(errors.NetTaxableIncome) && touched.NetTaxableIncome}
						errorMsg={errors.NetTaxableIncome}
						isDisabled={true}
						allowNegative={true}
					/>
				</FormField>
			</section>
		</>
	);
};

export default RINetTaxableIncomeForm;
